import { ref } from 'vue'
import { defineStore } from 'pinia'
import { axiosApi } from '@/api'
import { useAlertStore } from '@/stores/alert'

export const usePersonalizationRuleStore = defineStore('personalizationRule', () => {
  const alert = useAlertStore()
  const isLoadingActions = ref(false)
  const isLoadingConditionFields = ref(false)
  const actions = ref([])
  const conditionFields = ref([])

  async function fetchActions() {
    isLoadingActions.value = true
    try {
      const { data } = await axiosApi.get('/personalization_rule/actions/')
      actions.value = data
    } catch (error) {
      alert.error('An error occurred while fetching the personalization rule actions.')
      console.log(error)
    } finally {
      isLoadingActions.value = false
    }
  }

  async function fetchConditionFields() {
    isLoadingConditionFields.value = true
    try {
      const { data } = await axiosApi.get('/personalization_rule/condition_fields/')
      conditionFields.value = data
    } catch (error) {
      alert.error('An error occurred while fetching the personalization rule condition fields.')
      console.log(error)
    } finally {
      isLoadingConditionFields.value = false
    }
  }

  return {
    isLoadingActions,
    isLoadingConditionFields,
    actions,
    conditionFields,
    fetchActions,
    fetchConditionFields
  }
})
